import { useMemo } from 'react';

import { ListingType } from 'algolia-api/types/ListingType';
import { Box } from 'components/Box/Box';
import { AMP_PAGE_HEADER_NAV_MAP } from 'components/PageHeader/Amp/AmpPageHeaderConstants';
import { getHomeUrl } from 'utils/searchHomePages';

import { AmpPageHeaderTopNavLink } from './AmpPageHeaderTopNavLink';

type Props = {
  index: number;
  navOption: keyof typeof AMP_PAGE_HEADER_NAV_MAP;
  fullSize?: boolean;
};

export function AmpPageHeaderMainLink({ index, navOption, fullSize }: Props) {
  const linkTo = useMemo(() => {
    if (navOption === 'EVENT') {
      return getHomeUrl(navOption as ListingType, {
        actionType: 'EVENT',
      });
    }

    if (navOption === 'VOLOP') {
      return getHomeUrl(navOption as ListingType, {
        actionType: 'VOLOP',
      });
    }

    return getHomeUrl(navOption as ListingType);
  }, [navOption]);

  return (
    <Box height="100%" key={navOption}>
      <AmpPageHeaderTopNavLink
        index={index}
        linkTo={linkTo}
        type={navOption}
        fullSize={fullSize}
        external={false}
      />
    </Box>
  );
}
